import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import ReactTooltip from "react-tooltip-lite";
import styles from "./tooltip.css";

function Tooltip(_ref) {
  var content = _ref.content,
      direction = _ref.direction,
      autoShow = _ref.autoShow,
      autoHide = _ref.autoHide,
      arrow = _ref.arrow,
      children = _ref.children,
      _ref$manual = _ref.manual,
      manual = _ref$manual === void 0 ? false : _ref$manual,
      withCloseButton = _ref.withCloseButton,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? "dark" : _ref$theme,
      onShow = _ref.onShow,
      onHide = _ref.onHide,
      onClose = _ref.onClose;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var autoShowTimeout = useRef();
  var autoHideTimeout = useRef();
  var themeStyles = {
    dark: {
      closeButton: styles.tooltipCloseButtonDark,
      contentInner: styles.tooltipContentInnerDark,
      content: styles.tooltipContentDark,
      contentColor: "#fff",
      contentBackground: "#333"
    },
    light: {
      closeButton: styles.tooltipCloseButtonLight,
      contentInner: styles.tooltipContentInnerLight,
      content: styles.tooltipContentLight,
      contentColor: "#000",
      contentBackground: "#fff"
    }
  };

  function handleHover() {
    if (manual) {
      return;
    } // Clear timeouts


    if (autoShowTimeout.current) {
      clearTimeout(autoShowTimeout.current);
    }

    if (autoHideTimeout.current) {
      clearTimeout(autoHideTimeout.current);
    } // Because of the way React Tooltip Lite is using isOpen prop


    if (isOpen !== undefined) {
      setIsOpen(undefined);
    } // Fire onShow or onHide callbacks
    // This version of react-tooltip-lite does not expose prop for callback when the tooltip is shown
    // so we have to track it on our own


    if (!opened) {
      onShow && onShow();
      setOpened(true);
    } else {
      onHide && onHide();
      setOpened(false);
    }
  }

  function handleClose() {
    setIsOpen(false);
    setOpened(false);
    onClose && onClose();
    autoHideTimeout.current && clearTimeout(autoHideTimeout.current);
  }

  useEffect(function () {
    if (!!autoShow) {
      autoShowTimeout.current = setTimeout(function () {
        setIsOpen(true);
        setOpened(true);
        onShow && onShow();
      }, autoShow * 1000);
    }

    if (!!autoHide) {
      autoHideTimeout.current = setTimeout(function () {
        setIsOpen(false);
        setOpened(false);
        onHide && onHide();
      }, autoHide * 1000);
    }

    return function () {
      // Clear timeouts
      if (autoShowTimeout.current) {
        clearTimeout(autoShowTimeout.current);
      }

      if (autoHideTimeout.current) {
        clearTimeout(autoHideTimeout.current);
      }
    };
  }, [autoShow, autoHide, onShow, onHide]);
  return React.createElement(ReactTooltip, {
    content: React.createElement(React.Fragment, null, withCloseButton && // eslint-disable-next-line react/jsx-no-literals
    React.createElement("button", {
      className: themeStyles[theme].closeButton,
      onClick: handleClose
    }, "\xD7"), React.createElement("div", {
      className: themeStyles[theme].contentInner,
      dangerouslySetInnerHTML: {
        __html: content
      }
    })),
    direction: direction,
    arrow: arrow,
    isOpen: isOpen,
    tipContentClassName: themeStyles[theme].content,
    background: themeStyles[theme].contentBackground,
    color: themeStyles[theme].contentColor,
    padding: withCloseButton ? "0.9rem" : "0.3rem 0.6rem",
    tagName: "span",
    useHover: !manual
  }, typeof children !== "string" ? React.createElement("span", {
    "data-testid": "inner-span",
    onMouseEnter: handleHover,
    onMouseLeave: handleHover
  }, children) : React.createElement("span", {
    "data-testid": "inner-span",
    onMouseEnter: handleHover,
    onMouseLeave: handleHover,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
}

export default Tooltip;